import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { colors } from "common";
import { getRandomInt } from "utils/number/get-random-int";

export const getRandomMuiColor = () => {
  const randomInt = getRandomInt(0, 19);
  switch (randomInt) {
    case 0:
      return colors.amber;
    case 1:
      return colors.blue;
    case 2:
      return colors.blueGrey;
    case 3:
      return colors.brown;
    // case 4:
    //   return colors.common;
    case 5:
      return colors.cyan;
    case 6:
      return colors.deepOrange;
    case 7:
      return colors.deepPurple;
    case 8:
      return colors.green;
    case 9:
      return colors.grey;
    case 10:
      return colors.indigo;
    case 11:
      return colors.lightBlue;
    case 12:
      return colors.lightGreen;
    case 13:
      return colors.lime;
    case 14:
      return colors.orange;
    case 15:
      return colors.pink;
    case 16:
      return colors.purple;
    case 17:
      return colors.red;
    case 18:
      return colors.teal;
    case 19:
      return colors.yellow;
    default:
      return colors.green;
  }
};

export const getBuildGalleryTagColor = (title) => {
  switch (title) {
    case "Streaming":
      return colors.orange;
    case "Gaming":
      return colors.red;
    case "Video Editing":
      return colors.yellow;
    case "Mid":
      return colors.blue;
    case "Entry":
      return colors.green;
    case "Casual Use":
      return colors.teal;
    case "Productivity & Gaming Use":
      return colors.purple;
    case "Performance Use":
      return colors.deepOrange;
    default:
      return getRandomMuiColor();
  }
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      borderRadius: 3,
      alignItems: "center",
      justifyContent: "center",
      paddingLeft: theme.spacing(0.5),
      marginTop: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
    },
  }),
  { index: 999 }
);

const BuildsGalleryTags = ({ title, fontSize = 11 }) => {
  const classes = useStyles();

  const tagsBgColor = useMemo(() => {
    return getBuildGalleryTagColor(title);
  }, [title]);

  return (
    <div className={classes.root} style={{ backgroundColor: tagsBgColor[200] }}>
      <Typography
        style={{ color: tagsBgColor[800], fontSize: fontSize, padding: "2px" }}
      >
        {title}
      </Typography>
    </div>
  );
};

export default BuildsGalleryTags;
BuildsGalleryTags.propTypes = {
  title: PropTypes.string,
};
